import React from "react";
import ReactApexChart from "react-apexcharts";
import { useTitle } from "../../../../../hooks/useTitle";
import { withAuth } from "../../../../../components/HOC/withAuth";
import CardContainer from "../../../../../components/CustomUI/CardContainer";
import { SectionSpinner, SectionEmpty } from "../../shared/utils";
import { RP_PRODUCTION_TEALS } from "../../shared/constants";
import ProductionReportShell from "../ProductionReportShell";
import { usePartProductionReport } from "../usePartProductionReport";

const ProductionByPartPerPart = () => {
  useTitle("Rovion MES - Üretim Özeti");
  const {
    filters,
    machines,
    shifts,
    loading,
    derived,
    fetchData,
    toasts,
    dismissToast,
  } = usePartProductionReport();

  const content = () => {
    if (loading) return <SectionSpinner />;
    if (!derived) return <SectionEmpty />;
    const { topParts } = derived;

    return (
      <CardContainer title="Üretim Özeti">
        <ReactApexChart
          type="bar"
          series={[{ name: "Üretim", data: topParts.map((p) => p.totalQty) }]}
          options={{
            chart: {
              type: "bar",
              toolbar: { show: false },
              fontFamily: "inherit",
              foreColor: "#64748b",
            },
            plotOptions: {
              bar: {
                horizontal: true,
                borderRadius: 4,
                distributed: true,
                barHeight: "72%",
              },
            },
            colors: topParts.map(
              (_, i) => RP_PRODUCTION_TEALS[i % RP_PRODUCTION_TEALS.length],
            ),
            fill: { opacity: 1 },
            xaxis: {
              categories: topParts.map((p) => p.partName || p.partCode),
              labels: { style: { colors: "#64748b", fontSize: "12px" } },
              axisBorder: { show: false },
              axisTicks: { show: false },
            },
            yaxis: {
              labels: { style: { colors: "#334155", fontSize: "12px" } },
            },
            dataLabels: {
              enabled: true,
              formatter: (v) => v.toLocaleString("tr-TR"),
              style: { colors: ["#fff"], fontSize: "11px", fontWeight: 600 },
            },
            legend: { show: false },
            grid: {
              borderColor: "#e2e8f0",
              strokeDashArray: 4,
              xaxis: { lines: { show: true } },
              yaxis: { lines: { show: false } },
            },
            tooltip: {
              theme: "light",
              y: { formatter: (v) => v.toLocaleString("tr-TR") },
            },
          }}
          height={Math.max(220, topParts.length * 42)}
        />
      </CardContainer>
    );
  };

  return (
    <ProductionReportShell
      title="Üretim Özeti"
      filters={filters}
      machines={machines}
      shifts={shifts}
      onApply={fetchData}
      toasts={toasts}
      dismissToast={dismissToast}
    >
      {content()}
    </ProductionReportShell>
  );
};

export default withAuth(ProductionByPartPerPart);
